import { useEffect, useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { SinglePlayer } from '../../../Api/Players/models';
import toast from 'react-hot-toast';
import { useCreatePlayerAndUser } from '../../NewPlayerRequest/hooks/useCreatePlayerAndUser';
import { useAdminInfo } from '../../../../../hooks/useAdminInfo';
interface EditPlayerModalProps {
    show: boolean;
    onHide: () => void;
    player: SinglePlayer | null;
}

export const CreateUserAndPlayerModal = ({ show, onHide, player }: EditPlayerModalProps) => {
    const { adminInfo } = useAdminInfo()
    const [loading, setLoading] = useState(false)

    const [form, setForm] = useState<any>({
        firstName: player?.firstName || '',
        lastName: player?.lastName || '',
        email: player?.email || '',
        phone: player?.phone || '',
        platformUser: player?.platformUser || (adminInfo?.firstLetter ?? ''),
        password: '',
    });

    const { handleCreateUser } = useCreatePlayerAndUser({
        loading,
        setLoading,
        form,
        setForm,
        adminInfo,
        onHide,
    })

    const handleSubmit = async () => {
        if (loading) { return }
        if (!form.platformUser) {
            toast.error('Debe ingresar un usuario de la plataforma')
            return
        }

        // if (!form.email) {
        //     toast.error('Debe ingresar un email')
        //     return
        // }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (form?.email && !emailRegex.test(form?.email)) {
            toast.error('Introduce un email válido');
            return false
        }

        // if (!form.phone) {
        //     toast.error('Debe ingresar un teléfono')
        //     return
        // }

        if (!form.password) {
            toast.error('Debe ingresar una contraseña')
            return
        }

        if (form.password.length < 6) {
            toast.error('La contraseña debe tener al menos 6 caracteres')
            return
        }

        setLoading(true)
        handleCreateUser()

    };

    useEffect(() => {
        if (!player && adminInfo?.firstLetter) {
            setForm({
                ...form,
                platformUser: adminInfo?.firstLetter ?? ''
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [adminInfo]);

    return (
        <>

            <Modal show={show} onHide={onHide} centered>
                <div className="border border-secondary rounded-3">
                    <Modal.Header closeButton>
                        <Modal.Title>Crear Jugador en Gestor & Plataforma</Modal.Title>
                    </Modal.Header>
                    <Modal.Body >
                        <Form>
                            <Form.Group className="mb-3" controlId="formBasicCBU">
                                <Form.Label>Usuario de la plataforma</Form.Label>
                                <Form.Control type="text" maxLength={12} placeholder="Ingrese el usuario de la plataforma" value={form.platformUser} onChange={(e) => setForm({ ...form, platformUser: e.target.value })} />
                            </Form.Group>

                            <Form.Group className="mb-3" controlId="formBasicCBU">
                                <Form.Label>Nombre</Form.Label>
                                <Form.Control type="text" placeholder="Ingrese el nombre" value={form.firstName} onChange={(e) => setForm({ ...form, firstName: e.target.value })} />
                            </Form.Group>

                            <Form.Group className="mb-3" controlId="formBasicAlias">
                                <Form.Label>Apellido</Form.Label>
                                <Form.Control type="text" placeholder="Ingrese el apellido" value={form.lastName} onChange={(e) => setForm({ ...form, lastName: e.target.value })} />
                            </Form.Group>

                            <Form.Group className="mb-3" controlId="formBasicTitular">
                                <Form.Label>Email</Form.Label>
                                <Form.Control type="text" placeholder="Ingrese el email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
                            </Form.Group>

                            <Form.Group className="mb-3" controlId="formBasicHourLimit">
                                <Form.Label>Teléfono</Form.Label>
                                <Form.Control type="text" placeholder="Ingrese el teléfono" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} />
                            </Form.Group>

                            <Form.Group className="mb-3" controlId="formBasicHourLimit">
                                <Form.Label>Contraseña</Form.Label>
                                <Form.Control type="text" placeholder="Ingrese la contraseña" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} />
                                <Form.Text className="text-warning text-xs">
                                    * Esta contraseña es la que utilizará el jugador para entrar a su Gestor. <br />
                                    * La contraseña de la plataforma de juegos será {adminInfo?.default_users_password}
                                </Form.Text>
                            </Form.Group>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className='d-flex justify-content-between w-100'>
                            <Button variant="secondary" onClick={onHide}>
                                Cancelar
                            </Button>
                            <Button variant="primary" onClick={handleSubmit} disabled={loading}>
                                {loading ? 'Creando...' : 'Guardar'}
                            </Button>
                        </div>
                    </Modal.Footer>
                </div>
            </Modal>
        </>

    );
};
